<template>
  <div class="report-screen">
    <section class="report-hero">
      <p class="report-hero__eyebrow">내 메타인지 진단 리포트</p>
      <span>지금까지 {{ report.assessmentId }}명이 참가한 테스트예요!</span>
    </section>

    <section class="report-card report-summary-card">
      <div><span>학습 레벨</span><strong>{{ report.level }}</strong></div>
      <div><span>총점</span><strong>{{ report.totalScore }} / {{ report.maxScore }}</strong></div>
      <div><span>평균</span><strong>{{ report.averageScore.toFixed(1) }} / 5.0</strong></div>
    </section>

    <section class="report-card">
      <RadarChart :labels="report.axisLabels" :scores="report.axisScores" />
    </section>

    <section class="report-section">
      <h3>강점 요약</h3>
      <p>{{ report.strengths }}</p>
    </section>
    <section class="report-section">
      <h3>보완점</h3>
      <p>{{ report.improvements }}</p>
    </section>
    <section class="report-section">
      <h3>총평</h3>
      <p>{{ report.summary }}</p>
    </section>
    <section class="report-section report-section--training">
      <h3>트레이닝 안내</h3>
      <p>{{ report.training }}</p>
    </section>

    <div class="report-actions">
      <button class="report-button report-button--light" type="button" @click="$emit('restart')">테스트 결과 공유</button>
      <button class="report-button report-button--dark" type="button">트레이닝 사이트 방문</button>
    </div>
    <button class="text-reset-button" type="button" @click="$emit('restart')">처음부터 다시 보기</button>
  </div>
</template>

<script setup lang="ts">
import RadarChart from '@/components/RadarChart.vue'
import type { FixedReport } from '@/types/content'

defineProps<{ report: FixedReport }>()
defineEmits<{ restart: [] }>()
</script>
